"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryFindTransferRates = void 0;
const dayjs = require("dayjs");
const loadTransferRates_1 = require("./loadTransferRates");
const tryFindTransferRates = async (supabase, rates, from_area, to_area, via_area, type, date) => {
    const outbound_from = from_area.id;
    const outbound_to = via_area ? via_area.id : to_area.id;
    const inbound_from = via_area ? via_area.id : to_area.id;
    const inbound_to = via_area ? to_area.id : from_area.id;
    const current_rates = await (0, loadTransferRates_1.loadTransferRates)(supabase, rates, outbound_from, outbound_to, inbound_from, inbound_to, type, dayjs(date).format("YYYY-MM-DD"));
    if ((current_rates?.outbound?.length > 0 &&
        current_rates?.inbound?.length > 0) ||
        current_rates?.custom?.length > 0) {
        return {
            ...current_rates,
            offset: 0,
            historical: false,
        };
    }
    else {
        // try to get one year previously
        let historical_rates = await (0, loadTransferRates_1.loadTransferRates)(supabase, rates, outbound_from, outbound_to, inbound_from, inbound_to, type, dayjs(date).subtract(1, "year").format("YYYY-MM-DD"));
        if ((historical_rates?.outbound?.length > 0 ||
            historical_rates?.custom?.length > 0) &&
            historical_rates?.inbound?.length > 0) {
            return {
                ...historical_rates,
                offset: 1,
                historical: true,
            };
        }
        // try to get two years previously
        historical_rates = await (0, loadTransferRates_1.loadTransferRates)(supabase, rates, outbound_from, outbound_to, inbound_from, inbound_to, type, dayjs(date).subtract(2, "year").format("YYYY-MM-DD"));
        if ((historical_rates?.outbound?.length > 0 ||
            historical_rates?.custom?.length > 0) &&
            historical_rates?.inbound?.length > 0) {
            return {
                ...historical_rates,
                offset: 2,
                historical: true,
            };
        }
    }
    return null;
};
exports.tryFindTransferRates = tryFindTransferRates;
